/* Kampaaniafiltri kasutajaliides: märkeruut, numbrid, pillid, tootevõrgu joonistamine. Vajab assets/kamp-core.js. */
(function () {
  var K = window.__kamp;
  if (!K || K.ui) return;
  K.ui = true;
  var P = K.P, IS_SEARCH = K.IS_SEARCH, SPECS = K.SPECS;
  var qs = K.qs, isOn = K.isOn, onList = K.onList, flag = K.flag, params = K.params;
  var colBase = K.colBase, ctxId = K.ctxId, keyOf = K.keyOf, items = K.items, cards = K.cards;
  var selected = K.selected, attr = K.attr, pass = K.pass, bump = K.bump;
  var busy = false, lastKey = '', timer;

  function setText(root, n, label) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), t, sample = root.__sample;
    while ((t = w.nextNode())) {
      if (sample && t.nodeValue.indexOf(sample) > -1) t.nodeValue = t.nodeValue.replace(sample, label);
      if (/\(\d+\)/.test(t.nodeValue) || /\d+\s+(toode|tulemust)/.test(t.nodeValue)) t.nodeValue = bump(t.nodeValue, n);
    }
  }

  /* ---------- read (märkeruudud) ---------- */
  var BOXES = [['#FacetsWrapperDesktop', false], ['.mobile-facets__main', true]];
  function build(box, mobile, s) {
    var first = box.querySelector('details.js-filter');
    var sample = first && first.querySelector('li');
    if (!sample) return null;
    var li = sample.cloneNode(true);
    var input = li.querySelector('input'), label = li.querySelector('label');
    var sv = input.value;
    ['data-url', 'data-count'].forEach(function (a) { input.removeAttribute(a); });
    input.name = s.param; input.value = '1'; input.id = 'Filter-' + s.param + '-' + (mobile ? 'm' : 'd');
    input.checked = false;
    label.htmlFor = input.id;
    label.classList.remove('disabled');
    li.__sample = sv;
    var inner = document.createElement('ul');
    inner.className = sample.parentElement.className + ' kamp-ul';
    inner.appendChild(li);
    var wrap = document.createElement('div');
    if (mobile) {
      wrap.className = 'kamp-mrow';
    } else {
      var e = sample.parentElement.parentElement;
      while (e && e !== first) {
        var w = document.createElement(e.tagName);
        w.className = e.className;
        w.appendChild(inner);
        inner = w;
        e = e.parentElement;
      }
      wrap.className = first.className.replace('js-filter', '').trim();
    }
    wrap.setAttribute('data-kamp-row', s.key + (mobile ? 'm' : 'd'));
    wrap.style.display = 'none';
    wrap.appendChild(inner);
    first.parentNode.insertBefore(wrap, first);
    var ct = typeof window[s.tot] === 'number' ? window[s.tot] : 0;
    if (!ct) { try { ct = parseInt(sessionStorage.getItem('kampTot:' + s.key + ':' + ctxId()) || '0', 10); } catch (x) {} }
    if (ct > 0) paintRow(wrap, s, ct, ct, isOn(s));
    return wrap;
  }
  function rows() {
    var out = { kamp: [] };
    BOXES.forEach(function (c) {
      var box = document.querySelector(c[0]);
      if (!box) return;
      var fd = box.querySelector('details.js-filter');
      SPECS.forEach(function (s) {
        var r = box.querySelector('[data-kamp-row="' + s.key + (c[1] ? 'm' : 'd') + '"]') || build(box, c[1], s);
        if (!r) return;
        if (fd && (r.compareDocumentPosition(fd) & Node.DOCUMENT_POSITION_PRECEDING)) fd.parentNode.insertBefore(r, fd);
        out[s.key].push(r);
      });
    });
    pills();
    tidyNative();
    return out;
  }
  /* Shopify enda tõeväärtusfiltri ("Reisisuuruses tooted") silt ja aktiivse filtri pill */
  function tidyNative() {
    document.querySelectorAll('.facets__boolean-item').forEach(function (b) {
      var w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT), t;
      while ((t = w.nextNode())) {
        if (/KAMPAANIATOODED/.test(t.nodeValue)) t.nodeValue = t.nodeValue.replace(/KAMPAANIATOODED/g, 'Reisisuuruses tooted');
      }
    });
    document.querySelectorAll('.active-facets .active-facets__button-inner').forEach(function (b) {
      var w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT), t;
      while ((t = w.nextNode())) {
        if (/Reisisuuruses tooted:\s*Jah/.test(t.nodeValue)) t.nodeValue = t.nodeValue.replace(/Reisisuuruses tooted:\s*Jah/, 'Reisisuuruses tooted');
      }
    });
  }
  /* ---------- aktiivsed filtrid (pillid "Filtreeri:" all) ---------- */
  function removeUrl(s) {
    var u = new URL(location.href);
    u.searchParams.delete(s.param); u.searchParams.delete('page');
    return u.pathname + u.search;
  }
  function allUrl() {
    if (!IS_SEARCH) return colBase();
    var q = new URLSearchParams(); q.set('q', qs().get('q') || '');
    if (qs().get('type')) q.set('type', qs().get('type'));
    return '/search?' + q.toString();
  }
  function pillHtml(key, label, href) {
    return '<facet-remove data-kamp-pill="' + key + '"><a href="' + href + '" class="active-facets__button active-facets__button--light" role="button"><span class="active-facets__button-inner button button--tertiary">' + label +
      '<span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close-small" viewBox="0 0 12 13"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"></path></svg></span>' +
      '<span class="visually-hidden">Eemalda filter</span></span></a></facet-remove>';
  }
  function pills() {
    var on = onList();
    document.querySelectorAll('.active-facets').forEach(function (c) {
      // tavaliste (serveri joonistatud) pillide eemaldamislingid peavad säilitama kampaania valiku
      c.querySelectorAll('facet-remove:not([data-kamp-pill]) a.active-facets__button').forEach(function (a) {
        var u = new URL(a.getAttribute('href'), location.origin), ch = false;
        on.forEach(function (s) { if (u.searchParams.get(s.param) !== '1') { u.searchParams.set(s.param, '1'); ch = true; } });
        if (ch) a.setAttribute('href', u.pathname + u.search);
      });
      var cur = Array.prototype.map.call(c.querySelectorAll('[data-kamp-pill]:not([data-kamp-pill="all"])'), function (e) { return e.dataset.kampPill; }).join();
      var want = on.map(function (s) { return s.key; }).join();
      if (cur !== want) {
        c.querySelectorAll('[data-kamp-pill]:not([data-kamp-pill="all"])').forEach(function (e) { e.remove(); });
        on.forEach(function (s) {
          var t = document.createElement('template');
          t.innerHTML = pillHtml(s.key, s.label, removeUrl(s));
          c.appendChild(t.content.firstChild);
        });
      }
      on.forEach(function (s) {
        var a = c.querySelector('[data-kamp-pill="' + s.key + '"] a');
        if (a) a.setAttribute('href', removeUrl(s));
      });
      var vf = c.querySelector('.active-facets-vertical-filter');
      if (vf) {
        var native = vf.querySelector('facet-remove:not([data-kamp-pill]) .active-facets__button-remove');
        var mine = vf.querySelector('[data-kamp-pill="all"]');
        if (on.length && !native && !mine) {
          var t2 = document.createElement('template');
          t2.innerHTML = '<facet-remove class="active-facets__button-wrapper" data-kamp-pill="all"><a href="' + allUrl() + '" class="active-facets__button-remove underlined-link" role="button"><span>Eemalda kõik</span></a></facet-remove>';
          vf.appendChild(t2.content.firstChild);
        } else if ((!on.length || native) && mine) { mine.remove(); }
      }
    });
  }
  function paintRow(r, s, total, n, on) {
    var li = r.querySelector('li'), input = r.querySelector('input'), label = r.querySelector('label');
    if (n !== null) setText(li, n, s.label);
    input.checked = on;
    var off = !on && n === 0;
    input.disabled = off;
    label.classList.toggle('disabled', off);
    r.style.display = (on || (total > 0 && n !== 0)) ? '' : 'none';
  }

  /* ---------- teiste filtrite numbrid, kui kampaania on sees ---------- */
  function applyFacets(base, sel) {
    var keys = Object.keys(base);
    document.querySelectorAll('#FacetsWrapperDesktop li, #FacetsWrapperDesktop .facets__boolean-item, .mobile-facets__main li, .mobile-facets__main .facets__boolean-item').forEach(function (li) {
      var i = li.querySelector('input[name^="filter."]');
      if (!i) return;
      var key = keyOf(i.name);
      if (!key) return;
      var n = 0;
      keys.forEach(function (h) {
        if (pass(base[h], sel, key) && attr(base[h], key).indexOf(i.value) > -1) n++;
      });
      var w = document.createTreeWalker(li, NodeFilter.SHOW_TEXT), t;
      while ((t = w.nextNode())) {
        if (/\(\d+\)/.test(t.nodeValue) || /\d+\s+toode/.test(t.nodeValue)) t.nodeValue = bump(t.nodeValue, n);
      }
      li.style.display = (n === 0 && !i.checked) ? 'none' : '';
    });
    document.querySelectorAll('#FacetsWrapperDesktop details.js-filter, .mobile-facets__main details.js-filter').forEach(function (d) {
      var lis = Array.prototype.slice.call(d.querySelectorAll('li'));
      if (!lis.length || d.querySelector('input[name^="filter.v.price"]')) return;
      if (d.dataset.kLimit === undefined) d.dataset.kLimit = lis.filter(function (l) { return !l.classList.contains('show-more-item'); }).length;
      var limit = parseInt(d.dataset.kLimit, 10) || lis.length;
      var elig = lis.filter(function (l) { return l.style.display !== 'none'; });
      elig.forEach(function (l, k) {
        if (k < limit) { l.classList.remove('show-more-item', 'hidden'); }
        else { l.classList.add('show-more-item', 'hidden'); }
      });
      var btn = d.querySelector('show-more-button');
      if (btn) btn.style.display = elig.length > limit ? '' : 'none';
      d.style.display = elig.length ? '' : 'none';
    });
  }

  /* ---------- tootevõrgu joonistamine ---------- */
  function gridList(g) { return g.matches('ul') ? g : (g.querySelector('ul.product-grid') || g); }
  function render(keepEls, key) {
    var g = document.getElementById('product-grid');
    if (!g) return;
    var ul = gridList(g);
    var frag = document.createDocumentFragment();
    keepEls.forEach(function (it) { frag.appendChild(document.importNode(it, true)); });
    ul.innerHTML = '';
    ul.appendChild(frag);
    if (!keepEls.length) ul.innerHTML = '<li style="grid-column:1/-1;padding:2rem 0">Sobivaid tooteid ei leitud.</li>';
    g.dataset.kamp = key;
    document.querySelectorAll('.load-more-container, nav.pagination, .pagination-wrapper').forEach(function (e) { e.style.display = 'none'; });
    document.querySelectorAll('#ProductCount, #ProductCountDesktop, .product-count__text, .mobile-facets__count').forEach(function (e) {
      var w = document.createTreeWalker(e, NodeFilter.SHOW_TEXT), t;
      while ((t = w.nextNode())) {
        if (/\d+\s*\/\s*\d+\s+(toode|tulemust)/.test(t.nodeValue)) t.nodeValue = t.nodeValue.replace(/\d+(\s*\/\s*\d+\s+(?:toode|tulemust))/, keepEls.length + '$1');
        else if (/\d+\s+(toode|tulemust)/.test(t.nodeValue)) t.nodeValue = t.nodeValue.replace(/\d+(\s+(?:toode|tulemust))/, keepEls.length + '$1');
      }
    });
  }

  function run() {
    var grid = document.getElementById('product-grid');
    if (!grid || busy) return;
    var rs = rows();
    var on = onList(), key = location.pathname + '?' + params().toString() + '|' + on.map(function (s) { return s.key; }).join();
    if (!rs.kamp.length) return;
    var needRender = on.length > 0 && grid.dataset.kamp !== key;
    if (key === lastKey && !needRender && rs.kamp[0].dataset.done === key) return;
    busy = true;
    if (needRender) document.documentElement.classList.add('kamp-loading');
    var sid = grid.dataset.id;
    items().then(function (all) {
      var sel = selected(), hs = Object.keys(all);
      lastKey = key;
      var cur = rows();
      SPECS.forEach(function (s) {
        var others = on.filter(function (o) { return o !== s; });
        var total = hs.filter(function (h) { return flag(all[h], s); }).length;
        try { sessionStorage.setItem('kampTot:' + s.key + ':' + ctxId(), String(total)); } catch (e) {}
        var n = hs.filter(function (h) {
          var it = all[h];
          return flag(it, s) && others.every(function (o) { return flag(it, o); }) && pass(it, sel, null);
        }).length;
        cur[s.key].forEach(function (r) { r.dataset.done = key; paintRow(r, s, total, n, isOn(s)); });
      });
      if (!on.length) return;
      var base = {}, matched = [];
      hs.forEach(function (h) {
        if (on.every(function (s) { return flag(all[h], s); })) {
          base[h] = all[h];
          if (pass(all[h], sel, null)) matched.push(h);
        }
      });
      applyFacets(base, sel);
      var set = {};
      matched.forEach(function (h) { set[h] = 1; });
      return cards(sid, set).then(function (list) {
        if (needRender) render(list.filter(function (c) { return set[c.h]; }).map(function (c) { return c.el; }), key);
        applyFacets(base, sel);
      });
    }).catch(function () {}).then(function () {
      busy = false;
      document.documentElement.classList.remove('kamp-loading');
      var k2 = location.pathname + '?' + params().toString() + '|' + onList().map(function (s) { return s.key; }).join();
      if (k2 !== key || (onList().length && document.getElementById('product-grid').dataset.kamp !== key)) schedule(60);
    });
  }
  function schedule(ms) { clearTimeout(timer); timer = setTimeout(run, ms || 120); }

  /* märkeruudud saadavad päringu kohe, mitte alles 800 ms pärast (Shopify vaikimisi viide on mõeldud tekstiväljadele) */
  var pend;
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || t.type !== 'checkbox' || !t.closest) return;
    var f = t.closest('facet-filters-form');
    if (!f || typeof f.onSubmitHandler !== 'function') return;
    e.stopImmediatePropagation();
    clearTimeout(pend);
    pend = setTimeout(function () { f.onSubmitHandler(e); }, 120);
  }, true);
  /* kaardid eellaadima niipea, kui kasutaja filtri poole liigub */
  ['pointerover', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (K.isWarmed() || !e.target || !e.target.closest) return;
      if (e.target.closest('[data-kamp-row], .mobile-facets__open')) K.warm();
    });
  });

  var ps = history.pushState;
  history.pushState = function () { var r = ps.apply(this, arguments); schedule(150); return r; };
  window.addEventListener('popstate', function () { schedule(150); });
  new MutationObserver(function () { rows(); schedule(120); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(50); }); else schedule(50);
})();